// extracted by mini-css-extract-plugin
export default {"disabled":"Form_disabled__3Ktdt","form":"Form_form__RGHG-","amount":"Form_amount__w4Vnn","stripe":"Form_stripe__7QjBd"};